import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { CreditScoreQuestions, CreditScoreSoftAssessment } from './ApiEndPoints';
import { SoftQuestions } from 'pages/creditScore/CreditScoreInterface';

export interface ReportState {
  stepCount: number;
  reportData: any;
  loading: boolean;
  data: any;
  reportError: string;
  reportQuestions: SoftQuestions;
  vehicleAutoCompleteData: any;
  softAssesmentData: any;
}

const initialState: ReportState = {
  stepCount: 0,
  reportData: {},
  loading: false,
  data: {},
  reportError: '',
  // reportQuestions: {
  //   _id: '656466f384e0d871cd01df15',
  //   decision: 'Partial',
  //   questions: [
  //     {
  //       questionId: 1,
  //       questionText:
  //         'Your credit file indicates you may have a credit / store card which was opened approximately March 2024. Please choose the credit provider for this account.',
  //       choiceType: {
  //         type: 'SINGLE_CHOICE',
  //       },
  //       choices: [
  //         {
  //           choiceId: 1,
  //           choiceText: 'O P P CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 2,
  //           choiceText: 'LAKELAND CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 3,
  //           choiceText: 'RADVILLE CREDIT UNION LTD.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 4,
  //           choiceText: 'HUMBER VALLEY CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 5,
  //           choiceText: 'None of the Above',
  //           isCorrect: true,
  //         },
  //       ],
  //     },
  //     {
  //       questionId: 2,
  //       questionText:
  //         'Your credit file indicates you may have an auto loan/lease which was opened approximately May 2023. Please choose the credit provider for this account from the following options',
  //       choiceType: {
  //         type: 'SINGLE_CHOICE',
  //       },
  //       choices: [
  //         {
  //           choiceId: 1,
  //           choiceText: 'CYPRESS CREDIT UNION LTD.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 2,
  //           choiceText: 'DBA BARON AUTO GROUP',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 3,
  //           choiceText: 'PORTAGE CREDIT UNION LTD.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 4,
  //           choiceText: 'OMNI AUTO FINANCE INC.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 5,
  //           choiceText: 'None of the Above',
  //           isCorrect: true,
  //         },
  //       ],
  //     },
  //     {
  //       questionId: 3,
  //       questionText:
  //         'Your credit file indicates you may have a line of credit which was opened approximately September 2021. Please choose the credit provider for this account from the following options. ',
  //       choiceType: {
  //         type: 'SINGLE_CHOICE',
  //       },
  //       choices: [
  //         {
  //           choiceId: 1,
  //           choiceText: 'RAPPORT CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 2,
  //           choiceText: 'PORTAGE CREDIT UNION LTD.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 3,
  //           choiceText: 'ICICI BANK',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 4,
  //           choiceText: 'SYDNEY CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 5,
  //           choiceText: 'None of the Above',
  //           isCorrect: true,
  //         },
  //       ],
  //     },
  //     {
  //       questionId: 4,
  //       questionText:
  //         'Your credit file indicates you may have a telephone account which was opened approximately September 2020. Please choose the credit provider for this account.',
  //       choiceType: {
  //         type: 'SINGLE_CHOICE',
  //       },
  //       choices: [
  //         {
  //           choiceId: 1,
  //           choiceText: 'Sogetel',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 2,
  //           choiceText: 'SaskTel',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 3,
  //           choiceText: 'VIDEOTRON',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 4,
  //           choiceText: 'Eastlink',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 5,
  //           choiceText: 'None of the Above',
  //           isCorrect: true,
  //         },
  //       ],
  //     },
  //   ],
  // },
  reportQuestions: {
    _id: '',
    decision: '',
    questions: [],
  },
  vehicleAutoCompleteData: [],
  softAssesmentData: {},
};

export const postQuestions = createAsyncThunk('report/questions', async (data: any) => {
  try {
    const response = await axios.post(CreditScoreQuestions, data);

    return response.data;
  } catch (e) {
    console.log(e);
  }
});

export const softAssesment = createAsyncThunk('report/softAssesment', async (data: any) => {
  try {
    const response = await axios.post(CreditScoreSoftAssessment, data);
    return response.data;
  } catch (e) {
    console.log(e);
  }
});

export const vehicleLookupAutocomplete = createAsyncThunk(
  'report/vehicleLookupAutocomplete',
  async (searchText: string) => {
    try {
      const response = await axios.get(
        `https://service.canadianblackbook.com/UsedCarWS/CanUsedAPI/Autocomplete?searchText=${searchText}&country=C`,
        {
          auth: {
            username: 'CoreDlr-API',
            password: 'CGfBkDU4bAqH',
          },
        }
      );
      return response.data;
    } catch (e) {
      console.log(e);
    }
  }
);

export const reportState = createSlice({
  name: 'report',
  initialState,
  reducers: {
    stepIncrement: (state) => {
      state.stepCount += 1;
    },
    updateReportData: (state, action) => {
      state.reportData.person = {
        ...state.reportData.person,
        ...action.payload,
      };
    },
    clearVehicleAutoCompleteData: (state) => {
      return {
        ...state,
        vehicleAutoCompleteData: initialState.vehicleAutoCompleteData,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postQuestions.pending, (state) => {
        state.loading = true;
      })
      .addCase(postQuestions.fulfilled, (state, action) => {
        console.log('action.payload', action);
        state.loading = false;
        // state.reportQuestions = state.reportQuestions;
        state.reportQuestions = action.payload.message;
      })
      .addCase(postQuestions.rejected, (state, action) => {
        state.loading = false;
        state.reportError = ''; //FIXME : change me later
      })
      .addCase(vehicleLookupAutocomplete.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleAutoCompleteData = action.payload.autocomplete;
      })
      .addCase(softAssesment.pending, (state) => {
        state.loading = true;
      })
      .addCase(softAssesment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(softAssesment.rejected, (state, action) => {
        state.loading = false;
        state.softAssesmentData = ''; //FIXME : change me later
      });
  },
});

// Action creators are generated for each case reducer function
export const { stepIncrement, updateReportData, clearVehicleAutoCompleteData } = reportState.actions;
export default reportState.reducer;
